import React, { useState } from 'react';

interface BulkActionsProps {
  selectedCount: number;
  onBulkStatusUpdate: (status: string) => void;
}

const BulkActions: React.FC<BulkActionsProps> = ({ selectedCount, onBulkStatusUpdate }) => {
  const [bulkStatus, setBulkStatus] = useState('');

  const handleBulkUpdate = () => {
    if (!bulkStatus) {
      alert('Please select a status');
      return;
    }
    onBulkStatusUpdate(bulkStatus);
    setBulkStatus('');
  };

  return (
    <div className="bulk-actions-toolbar mb-4">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">
            <span>⚡</span>
            Bulk Actions
          </h4>
          <p className="card-description">Perform actions on selected signups</p>
        </div>
        
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label" htmlFor="bulkStatus">Change Status</label>
            <select 
              id="bulkStatus" 
              value={bulkStatus}
              onChange={(e) => setBulkStatus(e.target.value)}
              className="form-select"
            >
              <option value="">Select Status</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
              <option value="invited">Invited</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Selection Info</label>
            <div className="flex items-center gap-4">
              <button 
                className="btn btn-primary" 
                onClick={handleBulkUpdate} 
                disabled={selectedCount === 0}
              >
                Update Selected
              </button>
              <span className="text-sm text-gray-600">{selectedCount} selected</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;
